// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MK7Q","rootMobile":"styles_rootMobile__2Wj5_"};